import {FieldValues, UseFormRegister, UseFormSetValue} from "react-hook-form";

export interface IHierarchySWOT{
    mee001Id:number,
    mea001Id: number;
    register: UseFormRegister<FieldValues>;
    selectOptions?: "multi" | "single";
    initialData?:Array<number>;
    setValue:UseFormSetValue<FieldValues>
}
export enum SWOTHierarchyLevel {
    SECTION  = 1,
    ITEM = 2,
}
